// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Coupon from '../_raw/ui/icon_coupon.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Coupon);
